import RelatorioListarTurmaPage from "@/Pages/Relatorios/ListarTurmaPage.vue";
import lancarRelatorioBNCCPage from "@/Pages/Relatorios/lancarRelatorioBNCCPage.vue";
import relatorioPage from "@/Pages/Relatorios/index.vue";
import store from "@/store";
import authService from "@/Services/AuthService";
import { can } from "@/plugins/can";
import { aplicarModulos } from "./modulos";

const checkPermission = (permissions) => {
  return async (to, from, next) => {
    const user = store.getters["Auth/user"];
    if (!user && authService.isLoggedIn()) {
      try {
        await authService.syncUserWithStore();
      } catch (e) {
        // ignore
      }
    }
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

const rotas = [
  {
    path: "/relatorios/:franquiaId",
    name: "relatorios",
    component: relatorioPage,
    beforeEnter: checkPermission(["relatorios.*", "relatorios.visualizar"]),
  },
  {
    path: "/relatorios/visualizar/:gestaoDeAulasId/:turmaId",
    name: "relatorios.visualizar",
    component: RelatorioListarTurmaPage,
  },
  {
    path: "/relatorios/lancarRelatorioBNCC/:matricula_id",
    name: "relatorios.lancarRelatorioBNCC",
    component: lancarRelatorioBNCCPage,
  },
];

// Rota => módulo (Administração > Configurações).
const MODULO_POR_ROTA = {
  relatorios: "relatorios",
  "relatorios.visualizar": "relatorios",
  "relatorios.lancarRelatorioBNCC": "relatorios",
};

export default aplicarModulos(rotas, MODULO_POR_ROTA);
